import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ExportFootDes.css';
import moment from 'moment';
import { getSessionQuery, toThousands } from '../../utils';
import { buttomDate } from '../../routes/exportPDF/exportPDFConfig';

class ExportFootDes extends React.Component {
  
  constructor () {
    super();
    this.state = {
      num: 0
    };
  }


  componentDidMount () {
    const somedata = getSessionQuery('somedata')
    this.setState({
      num: somedata.contentNum
    })
  }

  render () {
    
    const name = this.props.name || '数据说明';
    const {brandName, beginTime, endTime} = this.props;
    const num = this.state.num || 0;
    return (
      <div className={s.container}>
        <span className={s.title}>{name}：</span>
        <span>
        { (beginTime && endTime)
          ? `本页图表数据观测窗口为${moment(beginTime).format(buttomDate)}-${moment(endTime).format(buttomDate)}，数据源来自微博、微信、今日头条、知乎四大国内主流社交媒体平台上的用户行为信息和UGC内容。与${brandName}相关的内容贴总数为：${toThousands(num || 0)} 条。`
          : this.props.children
        }
        </span>
      </div>
    );
  }
}

export default withStyles(s)(ExportFootDes);


// WEBPACK FOOTER //
// src/components/ExportFootDes/ExportFootDes.js